export default {
  watch: {
    Canvas: { handler(val) { if(!val || Object.keys(val).length === 0) return; this.register(this.draw); }, deep: true },
    Text: { handler(val) { if(!val || Object.keys(val).length === 0) return; this.register(this.draw); }, deep: true },
    DataItems: { handler(val) { if(!val || Object.keys(val).length === 0) return; this.register(this.draw); }, deep: true },

    // //for pdf
    // selectedItems() {
    //   this.$emit('selectedItems', this.selectedItems)
    // },
  },
}